module.exports = __webpack_public_path__ + "img/login-bg.bedfe6ea.png";